module.exports = __webpack_public_path__ + "img/P150T_weapon_143.ae552e53.png";